<template>
    <b-modal v-model="visibile" title="Registra Erogazione" size="lg">
        <div v-if="dettaglio">
            <div v-if="bozzaCaricata && !modalitaMultipla" class="alert alert-info py-2 mb-3">
                <i class="fas fa-info-circle"></i>
                Bozza salvata il {{ formatDateTime(bozzaCaricata.updateDate) }}: operatore, date e note sono stati ripristinati.
            </div>

            <div class="alert alert-light border mb-3">
                <div class="row">
                    <div class="col-md-6">
                        <strong>Assistito:</strong> {{ dettaglio.cognomeAssistito }} {{ dettaglio.nomeAssistito }}<br />
                        <strong>Codice Fiscale:</strong> {{ dettaglio.codiceFiscaleAssistito }}
                    </div>
                    <div class="col-md-6">
                        <strong>idPai:</strong> {{ dettaglio.idPai || idPaiCorrente }}<br />
                        <strong>ASL:</strong> {{ dettaglio.codiceAslAutore }}
                    </div>
                </div>
            </div>

            <div class="mb-3" v-if="!modalitaMultipla">
                <strong class="d-block mb-1">Prestazioni da erogare ({{ prestazioniSelezionate.length }}):</strong>
                <span v-for="p in prestazioniSelezionate" :key="p.id" class="badge badge-outline-secondary mr-2 mb-1"> {{ p.codicePrestazione }} - {{ p.descrizionePrestazione }} </span>
            </div>

            <!-- Modalita' multipla: piu' accessi distinti in un solo invio
                 (N chiamate sequenziali, un Encounter/Bundle per accesso -
                 non un Bundle unico, per non presumere che AnDIamo accetti
                 piu' Encounter insieme). Ogni accesso mantiene i propri dati
                 reali (data, codice accesso, prestazioni): qui si sceglie
                 solo l'operatore, comune a tutti. -->
            <div v-if="modalitaMultipla" class="mb-3">
                <strong class="d-block mb-2">Accessi selezionati ({{ accessiConPrestazioniMultipla.length }}):</strong>
                <b-table :items="accessiConPrestazioniMultipla.map((a) => a.accesso)" :fields="fieldsRiepilogoMultiplo" small striped>
                    <template #cell(periodo)="{ item }">{{ formatDateTime(item.dataOraInizio) }}</template>
                    <template #cell(esito)="{ item }">
                        <span v-if="esitiMultiplo[item.codiceAccesso] === 'OK'" class="badge badge-success">Inviata</span>
                        <span v-else-if="esitiMultiplo[item.codiceAccesso] === 'KO'" class="badge badge-danger">Errore</span>
                        <span v-else-if="invioInCorso" class="badge badge-light border">In attesa</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                </b-table>
            </div>

            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group label="Operatore *">
                        <b-form-select v-model="operatoreSelezionato" :options="opzioniOperatori" @change="onCambiaOperatore" />
                        <small class="text-muted">Elenco da "Gestione Utenti" (gesan_andiamo_utenti), solo attivi</small>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Tipo Operatore *">
                        <b-form-select v-model="tipoOperatoreSelezionato" :options="opzioniTipoOperatore" @change="onCambiaTipoOperatore" disabled />
                        <small class="text-muted">Precompilato dal ruolo registrato per l'operatore scelto, modificabile</small>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!modalitaMultipla">
                <b-col cols="12" md="6">
                    <b-form-group label="Codice Accesso *">
                        <b-form-select v-model="form.codiceAccesso" :options="opzioniCodiciAccesso" @change="onCambiaCodiceAccesso" disabled />
                        <small class="text-muted">Codici reali gia' pianificati da AnDIamo per questo PAI/PEI</small>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Tipo Accesso / Gestione">
                        <b-input-group>
                            <b-form-select v-model="tipoAccessoSelezionato" :options="opzioniTipoAccesso" @change="onCambiaTipoAccesso" disabled />
                            <b-form-select v-model="tipoGestioneSelezionato" :options="opzioniTipoGestione" @change="onCambiaTipoGestione" disabled />
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!modalitaMultipla">
                <b-col cols="12" md="6">
                    <b-form-group label="Data/Ora Inizio *">
                        <date-picker format="DD/MM/YYYY HH:mm" value-type="date" type="datetime" v-model="dataOraInizio"></date-picker>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Data/Ora Fine *">
                        <date-picker format="DD/MM/YYYY HH:mm" value-type="date" type="datetime" v-model="dataOraFine"></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-form-group label="Note (opzionale, applicata a tutte le prestazioni selezionate)">
                <b-form-textarea v-model="form.note" rows="2" />
            </b-form-group>
        </div>
        <template #modal-footer="{ cancel }">
            <b-button variant="secondary" @click="cancel()">Annulla</b-button>
            <b-button v-if="!modalitaMultipla" variant="outline-primary" :disabled="salvataggioInCorso" @click="onSalvaBozza">
                <i class="fas fa-save"></i>
                Salva bozza
            </b-button>
            <b-button variant="success" :disabled="salvataggioInCorso || invioInCorso" @click="onConferma">
                <i class="fas fa-paper-plane"></i>
                Eroga
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import AndiamoMixin from "../mixins/AndiamoMixin";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
    components: { DatePicker },
    mixins: [AndiamoMixin],
    props: {
        dettaglio: { type: Object, default: null },
    },
    data() {
        return {
            visibile: false,
            idPaiCorrente: null,
            prestazioniSelezionate: [],
            modalitaMultipla: false,
            accessiConPrestazioniMultipla: [],
            esitiMultiplo: {},
            invioInCorso: false,
            salvataggioInCorso: false,
            bozzaCaricata: null,
            fieldsRiepilogoMultiplo: [
                { key: "codiceAccesso", label: "Codice Accesso" },
                { key: "periodo", label: "Data" },
                { key: "esito", label: "Esito" },
            ],
            dataOraInizio: null,
            dataOraFine: null,
            operatoreSelezionato: null,
            opzioniOperatori: [],
            opzioniCodiciAccesso: [],
            accessiDisponibili: [],
            tipoOperatoreSelezionato: null,
            tipoAccessoSelezionato: null,
            tipoGestioneSelezionato: null,
            opzioniTipoOperatore: [
                { value: "1", text: "1 - MMG" },
                { value: "2", text: "2 - PLS" },
                { value: "3", text: "3 - Infermiere" },
                { value: "4", text: "4 - Medico specialista" },
                { value: "5", text: "5 - Medico esperto in cure palliative" },
                { value: "6", text: "6 - Continuità assistenziale" },
                { value: "7", text: "7 - Psicologo" },
                { value: "8", text: "8 - Fisioterapista" },
                { value: "9", text: "9 - Logopedista" },
                { value: "10", text: "10 - OSS" },
                { value: "11", text: "11 - Dietista" },
                { value: "12", text: "12 - Assistente sociale del SSN" },
                { value: "13", text: "13 - Terapista occupazionale" },
                { value: "99", text: "99 - Altro" },
            ],
            opzioniTipoAccesso: [
                { value: "1", text: "1 - Programmato" },
                { value: "2", text: "2 - Non programmato" },
            ],
            opzioniTipoGestione: [
                { value: "1", text: "1 - Diretta" },
                { value: "2", text: "2 - Esternalizzata" },
            ],
            form: {
                codiceFiscaleAssistito: "",
                codiceFiscaleOperatore: "",
                tipoOperatoreCode: "",
                tipoOperatoreDisplay: "",
                codiceAccesso: "",
                codiceAsl: "",
                tipoAccessoCode: "",
                tipoAccessoDisplay: "",
                tipoGestioneCode: "",
                tipoGestioneDisplay: "",
                idPai: "",
                idPei: "",
                note: "",
            },
        };
    },
    methods: {
        /**
         * Apre la modale in modalita' MULTIPLA: piu' accessi distinti (con
         * il loro vero codiceAccesso, data, prestazioni gia' scelte) in un
         * solo click dell'operatore. Tecnicamente restano N chiamate
         * separate (una per accesso, in sequenza) - non un unico Bundle -
         * dato che la specifica prevede un solo Encounter per Bundle e non
         * ho conferma che AnDIamo ne accetti piu' di uno insieme.
         * Nessuna bozza in questa modalita': "Salva bozza" e' solo per
         * l'accesso singolo.
         * @param {Array} accessiConPrestazioni [{ accesso, prestazioni }]
         */
        apriMultiplo(accessiConPrestazioni) {
            if (!accessiConPrestazioni || !accessiConPrestazioni.length) {
                this.$bvToast.toast("Seleziona almeno un accesso", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.modalitaMultipla = true;
            this.bozzaCaricata = null;
            this.salvataggioInCorso = false;
            this.accessiConPrestazioniMultipla = accessiConPrestazioni;
            this.esitiMultiplo = {};
            this.invioInCorso = false;
            let primoAccesso = accessiConPrestazioni[0].accesso;
            this.idPaiCorrente = primoAccesso.idPai;
            this.prestazioniSelezionate = [];
            this.caricaOperatori(primoAccesso);
            this.form = {
                codiceFiscaleAssistito: this.dettaglio ? this.dettaglio.codiceFiscaleAssistito : "",
                codiceFiscaleOperatore: "",
                tipoOperatoreCode: primoAccesso.tipoOperatoreCode || "",
                tipoOperatoreDisplay: primoAccesso.tipoOperatoreDisplay || "",
                codiceAccesso: "",
                codiceAsl: primoAccesso.codiceAslServiceProvider || (this.dettaglio ? this.dettaglio.codiceAslAutore : ""),
                tipoAccessoCode: "",
                tipoAccessoDisplay: "",
                tipoGestioneCode: "",
                tipoGestioneDisplay: "",
                idPai: this.idPaiCorrente,
                idPei: "",
                note: "",
            };
            this.operatoreSelezionato = null;
            this.tipoOperatoreSelezionato = primoAccesso.tipoOperatoreCode || null;
            this.visibile = true;
        },
        /**
         * Apre la modale prefillata con i dati del PAI (assistito, ASL,
         * idPai) e delle prestazioni selezionate dalla view (idPei preso
         * dalla prima selezionata, che nell'uso tipico condividono lo
         * stesso accesso). Supporta sia erogazione totale (tutte le
         * prestazioni pendenti selezionate) che parziale (solo alcune):
         * la differenza e' interamente nel numero di elementi di
         * prestazioniSelezionate, il body inviato e' identico nella forma.
         *
         * Se per l'accesso esiste una bozza salvata, ne ripristina operatore,
         * date e note (le prestazioni restano quelle selezionate ora).
         *
         * @param {Array} prestazioniSelezionate prestazioni da erogare
         * @param {Object|null} accessoReale se valorizzato (riga di
         *   gesan_andiamo_accessi_letti, con il vero codice_accesso
         *   assegnato da AnDIamo), precompila codiceAccesso/date/tipoAccesso
         *   con i valori VERI invece di generarli. CONFERMATO da collaudo:
         *   "Registrazione accessi" falliva perche' inventavamo un
         *   codiceAccesso nostro invece di usare quello reale gia'
         *   pianificato da AnDIamo per quell'accesso.
         */
        apri(prestazioniSelezionate, accessoReale = null) {
            this.modalitaMultipla = false;
            if (!prestazioniSelezionate || !prestazioniSelezionate.length) {
                this.$bvToast.toast("Seleziona almeno una prestazione", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.salvataggioInCorso = false;
            this.invioInCorso = false;
            this.prestazioniSelezionate = prestazioniSelezionate;
            this.idPaiCorrente = (accessoReale && accessoReale.idPai) || (this.dettaglio ? this.dettaglio.idPai : null);
            this.caricaOperatori(accessoReale);
            this.caricaCodiciAccesso(prestazioniSelezionate[0].idPei, accessoReale);

            this.form = {
                codiceFiscaleAssistito: this.dettaglio ? this.dettaglio.codiceFiscaleAssistito : "",
                codiceFiscaleOperatore: "",
                tipoOperatoreCode: (accessoReale && accessoReale.tipoOperatoreCode) || "",
                tipoOperatoreDisplay: (accessoReale && accessoReale.tipoOperatoreDisplay) || "",
                codiceAccesso: (accessoReale && accessoReale.codiceAccesso) || "ACC-" + (this.idPaiCorrente || "X") + "-" + Date.now(),
                codiceAsl: (accessoReale && accessoReale.codiceAslServiceProvider) || (this.dettaglio ? this.dettaglio.codiceAslAutore : ""),
                tipoAccessoCode: (accessoReale && accessoReale.tipoAccessoCode) || "",
                tipoAccessoDisplay: (accessoReale && accessoReale.tipoAccessoDisplay) || "",
                tipoGestioneCode: (accessoReale && accessoReale.tipoGestioneCode) || "",
                tipoGestioneDisplay: (accessoReale && accessoReale.tipoGestioneDisplay) || "",
                idPai: this.idPaiCorrente,
                idPei: (accessoReale && accessoReale.idPei) || prestazioniSelezionate[0].idPei || "",
                note: "",
            };
            this.operatoreSelezionato = null;
            this.tipoOperatoreSelezionato = (accessoReale && accessoReale.tipoOperatoreCode) || null;
            this.tipoAccessoSelezionato = (accessoReale && accessoReale.tipoAccessoCode) || null;
            this.tipoGestioneSelezionato = (accessoReale && accessoReale.tipoGestioneCode) || null;
            this.dataOraInizio = accessoReale && accessoReale.dataOraInizio ? new Date(accessoReale.dataOraInizio) : new Date();
            this.dataOraFine = accessoReale && accessoReale.dataOraFine ? new Date(accessoReale.dataOraFine) : new Date();
            // Dopo form e date: la bozza ripristina note/date/operatore, che altrimenti
            // verrebbero sovrascritti dai valori di partenza qui sopra.
            this.caricaBozzaEsistente(this.form.codiceAccesso);
            this.visibile = true;
        },
        /**
         * Carica gli operatori attivi da gesan_andiamo_utenti (locale, non
         * chiama AnDIamo) per popolare la select, invece di lasciare
         * scrivere il codice fiscale a mano. Filtrati per tipoOperatoreCode:
         * se l'accesso richiede un Infermiere, in select compaiono solo gli
         * operatori registrati come Infermiere, non l'intero elenco attivi
         * indipendentemente dal ruolo. Se l'accesso reale ha gia' un
         * codiceFiscaleOperatore valido (non mascherato "-"), prova a
         * preselezionarlo nella lista una volta caricata.
         */
        caricaOperatori(accessoReale) {
            let me = this;
            let tipoOperatoreRichiesto = accessoReale && accessoReale.tipoOperatoreCode;
            let link = process.env.VUE_APP_PATH_API + me.andiamoUtentiLocaliPathResource;
            axios
                .get(link, { params: { stato: "ATTIVO" } })
                .then((response) => {
                    let lista = response.data.data.list || [];
                    if (tipoOperatoreRichiesto) {
                        lista = lista.filter((u) => u.tipoOperatoreCode === tipoOperatoreRichiesto);
                    }
                    me.opzioniOperatori = lista.map((u) => ({
                        value: u.codiceFiscaleOperatore,
                        text: u.cognome + " " + u.nome + " (" + u.codiceFiscaleOperatore + ") - " + (u.tipoOperatoreDisplay || u.tipoOperatoreCode),
                        _utente: u,
                    }));
                    if (tipoOperatoreRichiesto && !me.opzioniOperatori.length) {
                        me.$bvToast.toast("Nessun operatore registrato con il ruolo richiesto da questo accesso", { title: "Attenzione", variant: "warning", solid: true });
                    }
                    let cfPreselezionato = accessoReale && accessoReale.codiceFiscaleOperatore !== "-" ? accessoReale.codiceFiscaleOperatore : null;
                    if (cfPreselezionato && me.opzioniOperatori.some((o) => o.value === cfPreselezionato)) {
                        me.operatoreSelezionato = cfPreselezionato;
                        me.onCambiaOperatore(cfPreselezionato);
                    }
                })
                .catch(() => {
                    me.$bvToast.toast("Errore nel caricamento degli operatori registrati", { title: "Errore", variant: "danger", solid: true });
                });
        },
        /**
         * Carica i codici accesso REALI (gia' pianificati da AnDIamo) per
         * questo idPai/idPei, invece di lasciar scrivere/inventare un
         * codiceAccesso a mano. Se accessoReale e' gia' noto (arrivato dalla
         * lista Accessi), lo preseleziona; altrimenti (es. dal bottone
         * "Registra Erogazione" della view PAI, che non parte da un accesso
         * specifico) lascia scegliere tra quelli trovati.
         */
        caricaCodiciAccesso(idPei, accessoReale) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.andiamoAccessiPathResource;
            axios
                .get(link, { params: { idPai: me.idPaiCorrente, idPei: idPei, forPage: 100 } })
                .then((response) => {
                    let lista = response.data.data.list || [];
                    me.accessiDisponibili = lista;
                    me.opzioniCodiciAccesso = lista.map((a) => ({
                        value: a.codiceAccesso,
                        text: a.codiceAccesso + " — " + me.formatDateTime(a.dataOraInizio) + " (" + a.stato + ")",
                    }));
                    let codicePreselezionato = (accessoReale && accessoReale.codiceAccesso) || me.form.codiceAccesso;
                    if (codicePreselezionato && lista.some((a) => a.codiceAccesso === codicePreselezionato)) {
                        me.form.codiceAccesso = codicePreselezionato;
                    } else if (lista.length) {
                        me.form.codiceAccesso = lista[0].codiceAccesso;
                        me.onCambiaCodiceAccesso(lista[0].codiceAccesso);
                    } else {
                        me.opzioniCodiciAccesso = [{ value: me.form.codiceAccesso, text: me.form.codiceAccesso + " (generato, nessun accesso pianificato trovato)" }];
                    }
                })
                .catch(() => {
                    me.opzioniCodiciAccesso = [{ value: me.form.codiceAccesso, text: me.form.codiceAccesso + " (generato, nessun accesso pianificato trovato)" }];
                });
        },
        /**
         * Se l'operatore sceglie un accesso diverso da quello con cui e'
         * stata aperta la modale, riallinea anche gli altri campi collegati
         * (date, tipo accesso/gestione) a QUELLO scelto, non a quello di
         * partenza.
         */
        onCambiaCodiceAccesso(value) {
            let accesso = this.accessiDisponibili.find((a) => a.codiceAccesso === value);
            if (!accesso) {
                return;
            }
            this.form.codiceAsl = accesso.codiceAslServiceProvider || this.form.codiceAsl;
            this.form.tipoAccessoCode = accesso.tipoAccessoCode;
            this.form.tipoAccessoDisplay = accesso.tipoAccessoDisplay;
            this.form.tipoGestioneCode = accesso.tipoGestioneCode;
            this.form.tipoGestioneDisplay = accesso.tipoGestioneDisplay;
            this.tipoAccessoSelezionato = accesso.tipoAccessoCode;
            this.tipoGestioneSelezionato = accesso.tipoGestioneCode;
            this.dataOraInizio = accesso.dataOraInizio ? new Date(accesso.dataOraInizio) : this.dataOraInizio;
            this.dataOraFine = accesso.dataOraFine ? new Date(accesso.dataOraFine) : this.dataOraFine;
        },
        onCambiaOperatore(value) {
            let opzione = this.opzioniOperatori.find((o) => o.value === value);
            this.form.codiceFiscaleOperatore = value;
            if (opzione && opzione._utente) {
                // Precompila il ruolo dal registro utenti, ma resta modificabile
                // subito dopo (l'operatore potrebbe avere piu' ruoli).
                this.tipoOperatoreSelezionato = opzione._utente.tipoOperatoreCode;
                this.form.tipoOperatoreCode = opzione._utente.tipoOperatoreCode;
                this.form.tipoOperatoreDisplay = opzione._utente.tipoOperatoreDisplay;
            }
        },
        onCambiaTipoOperatore(value) {
            let o = this.opzioniTipoOperatore.find((x) => x.value === value);
            this.form.tipoOperatoreCode = value;
            this.form.tipoOperatoreDisplay = o ? o.text.split(" - ")[1] : "";
        },
        onCambiaTipoAccesso(value) {
            let o = this.opzioniTipoAccesso.find((x) => x.value === value);
            this.form.tipoAccessoCode = value;
            this.form.tipoAccessoDisplay = o ? o.text.split(" - ")[1] : "";
        },
        onCambiaTipoGestione(value) {
            let o = this.opzioniTipoGestione.find((x) => x.value === value);
            this.form.tipoGestioneCode = value;
            this.form.tipoGestioneDisplay = o ? o.text.split(" - ")[1] : "";
        },
        /**
         * Pulsante "Eroga": invia subito ad AnDIamo. Se per l'accesso c'e' una
         * bozza salvata, il backend la riusa (stessa riga): non ne resta una
         * orfana accanto all'erogazione inviata.
         */
        onConferma() {
            if (this.salvataggioInCorso) {
                return;
            }
            if (this.modalitaMultipla) {
                this.onConfermaMultiplo();
                return;
            }
            if (!this.form.codiceFiscaleOperatore || !this.form.tipoOperatoreCode || !this.form.codiceAccesso || !this.dataOraInizio || !this.dataOraFine) {
                this.$bvToast.toast("Compila tutti i campi obbligatori (*)", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            // CONFERMATO da collaudo: AnDIamo richiede sempre un idPei valorizzato
            // sulla Procedure - sia mandandolo vuoto (422 "value cannot be empty")
            // che omettendolo del tutto (500 "No value present", un crash non
            // gestito lato loro) viene rifiutato. Non e' aggirabile lato nostro:
            // blocchiamo qui con un messaggio chiaro invece di scoprirlo da un
            // errore imprevedibile di AnDIamo.
            if (!this.form.idPei) {
                this.$bvToast.toast("idPei mancante: questa prestazione non e' collegata a un PEI valido, l'erogazione non puo' essere inviata", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            let body = {
                ...this.form,
                dataOraInizio: moment(this.dataOraInizio).format(),
                dataOraFine: moment(this.dataOraFine).format(),
                prestazioni: this.prestazioniSelezionate.map((p) => ({
                    codicePrestazione: p.codicePrestazione,
                    descrizionePrestazione: p.descrizionePrestazione,
                    note: this.form.note,
                })),
            };
            delete body.note;
            // Disabilita i pulsanti durante la chiamata (anti doppio click) e li riabilita
            // anche se AnDIamo rifiuta, cosi' si puo' correggere e riprovare.
            this.salvataggioInCorso = true;
            this.andiamoInviaErogazione(body, this.onSalvaSuccess, (error) => {
                this.salvataggioInCorso = false;
                this.andiamoInviaErogazioneError(error);
            });
        },
        /**
         * Invia in sequenza un'erogazione per ciascun accesso selezionato
         * (stesso operatore per tutti, ognuno con i propri dati reali gia'
         * noti: codiceAccesso, date, prestazioni). Non interrompe la
         * sequenza al primo errore: prosegue con gli altri e mostra un
         * riepilogo finale di quanti sono andati a buon fine.
         */
        async onConfermaMultiplo() {
            if (!this.form.codiceFiscaleOperatore || !this.form.tipoOperatoreCode) {
                this.$bvToast.toast("Seleziona l'operatore prima di procedere", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            let senzaIdPei = this.accessiConPrestazioniMultipla.filter((a) => !a.accesso.idPei);
            if (senzaIdPei.length) {
                this.$bvToast.toast("Uno o piu' accessi selezionati non hanno un idPei valido: rimuovili dalla selezione prima di procedere", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.invioInCorso = true;
            let successi = 0;
            for (let elemento of this.accessiConPrestazioniMultipla) {
                let acc = elemento.accesso;
                let body = {
                    codiceFiscaleAssistito: this.form.codiceFiscaleAssistito,
                    codiceFiscaleOperatore: this.form.codiceFiscaleOperatore,
                    tipoOperatoreCode: this.form.tipoOperatoreCode,
                    tipoOperatoreDisplay: this.form.tipoOperatoreDisplay,
                    codiceAccesso: acc.codiceAccesso,
                    codiceAsl: acc.codiceAslServiceProvider || this.form.codiceAsl,
                    tipoAccessoCode: acc.tipoAccessoCode,
                    tipoAccessoDisplay: acc.tipoAccessoDisplay,
                    tipoGestioneCode: acc.tipoGestioneCode,
                    tipoGestioneDisplay: acc.tipoGestioneDisplay,
                    dataOraInizio: acc.dataOraInizio,
                    dataOraFine: acc.dataOraFine,
                    idPai: acc.idPai,
                    idPei: acc.idPei,
                    prestazioni: elemento.prestazioni.map((p) => ({
                        codicePrestazione: p.codicePrestazione,
                        descrizionePrestazione: p.descrizionePrestazione,
                        note: this.form.note,
                    })),
                };
                try {
                    await new Promise((resolve) => {
                        this.andiamoInviaErogazione(body, (response) => {
                            let esito = response && response.data && response.data.esito;
                            this.$set(this.esitiMultiplo, acc.codiceAccesso, esito ? "OK" : "KO");
                            if (esito) {
                                successi++;
                            }
                            resolve();
                        });
                    });
                } catch (e) {
                    this.$set(this.esitiMultiplo, acc.codiceAccesso, "KO");
                }
            }
            this.invioInCorso = false;
            this.$bvToast.toast(successi + " di " + this.accessiConPrestazioniMultipla.length + " accessi erogati con successo", {
                title: successi === this.accessiConPrestazioniMultipla.length ? "Completato" : "Completato con errori",
                variant: successi === this.accessiConPrestazioniMultipla.length ? "success" : "warning",
                solid: true,
            });
            this.$emit("registrata");
        },
        onSalvaSuccess(response) {
            this.salvataggioInCorso = false;
            this.andiamoInviaErogazioneSuccess(response);
            this.visibile = false;
            this.$emit("registrata");
        },
        /**
         * Pulsante "Salva bozza": salva nel nostro sistema SENZA inviare ad
         * AnDIamo. Bastano accesso e almeno una prestazione: operatore, date
         * e il resto si possono completare dopo (la completezza si pretende
         * solo all'invio).
         */
        onSalvaBozza() {
            if (this.salvataggioInCorso) {
                return;
            }
            if (!this.form.codiceAccesso || !this.prestazioniSelezionate.length) {
                this.$bvToast.toast("Servono almeno l'accesso e una prestazione", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            let body = {
                ...this.form,
                dataOraInizio: this.dataOraInizio ? moment(this.dataOraInizio).format() : null,
                dataOraFine: this.dataOraFine ? moment(this.dataOraFine).format() : null,
                prestazioni: this.prestazioniSelezionate.map((p) => ({
                    codicePrestazione: p.codicePrestazione,
                    descrizionePrestazione: p.descrizionePrestazione,
                    note: this.form.note,
                })),
            };
            delete body.note;
            this.salvataggioInCorso = true;
            axios
                .post(process.env.VUE_APP_PATH_API + this.andiamoErogazioniPathResource + "/bozza", body)
                .then((response) => {
                    this.salvataggioInCorso = false;
                    this.$bvToast.toast(response.data.messaggio || "Bozza salvata", { title: "", variant: "success", solid: true });
                    this.visibile = false;
                    this.$emit("bozza");
                })
                .catch((error) => {
                    this.salvataggioInCorso = false;
                    this.$bvToast.toast(error?.response?.data?.messaggio || error.message, { title: "Bozza non salvata", variant: "danger", solid: true });
                });
        },
        /**
         * Se per questo accesso esiste una bozza salvata, ne ripristina
         * operatore, date e note. Le prestazioni NON si ripristinano: restano
         * quelle selezionate ora nella lista (e verranno salvate al prossimo
         * "Salva bozza").
         */
        caricaBozzaEsistente(codiceAccesso) {
            this.bozzaCaricata = null;
            if (!codiceAccesso) {
                return;
            }
            axios
                .get(process.env.VUE_APP_PATH_API + this.andiamoErogazioniPathResource + "/locali", { params: { codiceAccesso: codiceAccesso, stato: "BOZZA", page: 1, forPage: 1 } })
                .then((response) => {
                    let lista = response.data.data.list || [];
                    if (!lista.length || !lista[0].inputJson) {
                        return;
                    }
                    let input = JSON.parse(lista[0].inputJson);
                    this.bozzaCaricata = lista[0];
                    this.form.note = (input.prestazioni && input.prestazioni.length && input.prestazioni[0].note) || "";
                    if (input.dataOraInizio) this.dataOraInizio = new Date(input.dataOraInizio);
                    if (input.dataOraFine) this.dataOraFine = new Date(input.dataOraFine);
                    if (input.codiceFiscaleOperatore) {
                        this.operatoreSelezionato = input.codiceFiscaleOperatore;
                        this.form.codiceFiscaleOperatore = input.codiceFiscaleOperatore;
                        this.form.tipoOperatoreCode = input.tipoOperatoreCode;
                        this.form.tipoOperatoreDisplay = input.tipoOperatoreDisplay;
                        this.tipoOperatoreSelezionato = input.tipoOperatoreCode;
                    }
                })
                .catch(() => {});
        },
    },
};
</script>

<style scoped></style>
